import './HomePage.css';
import { useEffect, useState } from 'react';
import SearchBar from '../components/SearchBar';
import BookCard from '../components/BookCard';
import PrivacyBanner from '../components/PrivacyBanner';
import {
  addFavorite,
  deleteFavorite,
  addOrUpdateRating,
  getFavorites,
  getRatings,
} from '../services/api';

// get base url
const BASE_URL = process.env.REACT_APP_API_URL;

function HomePage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedGenre, setSelectedGenre] = useState('');
  const [userId, setUserId] = useState(null); // ✅ use ID
  const [favorites, setFavorites] = useState([]);
  const [ratings, setRatings] = useState([]);

  const genres = ['fiction', 'fantasy', 'science', 'history', 'romance', 'thriller'];

  useEffect(() => {
    const storedId = localStorage.getItem('userId');
    setUserId(storedId || null);
    if (storedId) {
      fetchFavoritesAndRatings(storedId);
    }
    fetchBooks();
  }, [selectedGenre]);

  const checkPrivacyConsent = () => {
    const consent = localStorage.getItem('privacyConsent');
    return consent === 'accepted';
  };
  
  // Modify your useEffect to respect privacy consent
  useEffect(() => {
    if (checkPrivacyConsent()) {
      const storedId = localStorage.getItem('userId');
      setUserId(storedId || null);
      if (storedId) {
        fetchFavoritesAndRatings(storedId);
      }
    }
    fetchBooks();
  }, [selectedGenre]);
  const fetchFavoritesAndRatings = async (id) => {
    try {
      const favs = await getFavorites(id);
      const rated = await getRatings(id);
      setFavorites(Array.isArray(favs) ? favs : []);
      setRatings(Array.isArray(rated) ? rated : []);
    } catch (err) {
      console.error('Failed to load user favorites or ratings:', err);
      setFavorites([]);
      setRatings([]);
    }
  };
  const handleSearchBarFocus = () => {
    setSelectedGenre('');
  };

  const fetchBooks = async (query = '') => {
    const searchTerm = query || selectedGenre;
  
    if (!searchTerm) {
      setBooks([]); // Clear books if nothing to search
      return;
    }
  
    setLoading(true);
    try {
      let finalQuery = '';
  
      if (query) {
        // If manual search (query provided) → search normally
        finalQuery = `q=${encodeURIComponent(query)}`;
      } else {
        // If genre search (no manual query) → search by subject
        finalQuery = `q=subject:${encodeURIComponent(selectedGenre)}`;
      }
  
      const res = await fetch(`${BASE_URL}/search?${finalQuery}`);
      const data = await res.json();
  
      if (Array.isArray(data)) {
        setBooks(data.slice(0, 16));
      } else {
        setBooks([]);
      }
    } catch (err) {
      console.error('Error fetching books:', err);
      setBooks([]);
    }
    setLoading(false);
  };
  
  

  const handleGenreChange = (genre) => {
    setSelectedGenre(genre);
    
  };

  const handleFavorite = async (book) => {
    const isLoggedIn = !!localStorage.getItem('username');
    if (!isLoggedIn) {
      alert('You need to be logged in to favorite books.');
      return;
    }
    
    // Check if book is already in favorites
    const isFavorite = favorites.some(fav => fav.id === book.id);
    
    try {
      if (isFavorite) {
        // Remove from favorites
        await deleteFavorite(userId, book.id);
      } else {
        // Add to favorites
        await addFavorite(userId, book);
      }
      // Refresh favorites list after operation
      fetchFavoritesAndRatings(userId);
    } catch (err) {
      console.error(isFavorite ? 'Failed to remove favorite:' : 'Failed to save favorite:', err);
    }
  };

  const handleRating = async (book, ratingValue) => {
    const isLoggedIn = !!localStorage.getItem('username');
  if (!isLoggedIn) {
    alert('You need to be logged in to rate books.');
    return;
  }
    try {
      await addOrUpdateRating(userId, book, ratingValue);
      fetchFavoritesAndRatings(userId);
    } catch (err) {
      console.error('Failed to rate book:', err);
    }
  };

  return (
    <div className="homepage">
      <PrivacyBanner />
      <header className="homepage-header">

        <h1 className="homepage-title">📚 Bookmarkd</h1>
        <p className="homepage-subtitle">
        Your personal bookshelf hub—favorite, review, and rate your way through a world of books while connecting with fellow readers.
        </p>
        <SearchBar onSearch={fetchBooks} loading={loading} onFocus={handleSearchBarFocus} />
      </header>

      <div className="genre-container">
        <div className="genre-buttons">
          {genres.map((genre) => (
            <button
              key={genre}
              className={`genre-button ${selectedGenre === genre ? 'active' : ''}`}
              onClick={() => handleGenreChange(genre)}
            >
              {genre.charAt(0).toUpperCase() + genre.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="books-grid">
        {books.map(book => {
          const isFavorite = Array.isArray(favorites) && favorites.some(fav => fav.id === book.id);
          const ratedBook = ratings.find(r => r.id === book.id);
          const userRating = ratedBook?.userRating;

          return (
            <BookCard
              key={book.id}
              book={book}
              isFavorite={isFavorite}
              userRating={userRating}
              onFavorite={() => handleFavorite(book)}
              onRate={(value) => handleRating(book, value)}
              showRatingButton={true}
              showFavoriteButton={true}
              showDetailsLink={true}
            />
          );
        })}
      </div>
    </div>
  );
}

export default HomePage;
